import { get, post } from '../../utils/axios'

export const getSettingCertificate = async (body) => {
  return await get('payment/cer', body)
}

export const postSettingCertificateAPI = async (body) => {
  return await post('payment/cer', body)
}

export const updateSettingCertificateAPI = async (body) => {
  return await post('payment/cer/update', body)
}

export const deleteSettingCertificateAPI = async (body) => {
  return await post('payment/cer/delete', body)
}

export const getSettingCertificateGroupAPI = async (body) => {
  return await get('payment/cer/group', body)
}

export const getSettingCertificateCategoryAPI = async (body) => {
  return await get('payment/cer/category', body)
}

export const getSettingCertificateBrandAPI = async (body) => {
  return await get('payment/cer/brand', body)
}

export const getSettingCertificateLevelAPI = async (body) => {
  return await get('payment/cer/level', body)
}
